/** Subtle WATCH control for dossier pages — members, admins, owners.
 * Uses the existing watchlist toggle; Oracle monitors watched investigations. */
import React, { useEffect, useState } from "react";
import { Eye } from "lucide-react";
import { toast } from "sonner";
import { api } from "./commandApi";
import { useCallsign } from "./useCallsign";

export default function WatchButton({ slug }) {
  const identity = useCallsign();
  const eligible = identity && identity.role && identity.role !== "anonymous";
  const [watching, setWatching] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!eligible || !slug) return;
    api("/command/watchlist")
      .then((d) => setWatching((d.watchlist || []).some((w) => w.slug === slug)))
      .catch(() => {});
  }, [eligible, slug]);

  if (!eligible) return null;

  const toggle = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const r = await api("/command/watchlist/toggle", { method: "post", data: { slug } });
      setWatching(!!r.watching);
      if (r.watching) {
        toast("WATCHING INVESTIGATION", {
          description: "Oracle will surface meaningful changes.",
        });
      } else {
        toast("Watch removed", { description: "Oracle is no longer monitoring this investigation." });
      }
    } catch { /* no-op */ }
    setBusy(false);
  };

  return (
    <button type="button" onClick={toggle} data-testid="watch-button"
            aria-pressed={watching}
            className={`inline-flex items-center gap-2 px-3 py-1.5 border font-mono text-[10px] uppercase tracking-[0.25em] transition-colors ${
              watching
                ? "border-[#D92D20]/70 text-[#D92D20] bg-[#D92D20]/5"
                : "border-[#2D2A26] text-[#757065] hover:border-[#D92D20]/50 hover:text-[#A39E93]"}`}>
      <Eye size={12} className={watching ? "text-[#D92D20]" : ""} />
      {watching ? "Watching" : "Watch"}
    </button>
  );
}
